// frontend/src/utils/axios.ts
import axios from "axios";
import { getToken, logoutUser } from "@/services/auth";

const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  withCredentials: false, // set to true if you switch to cookie-based auth
});

// Automatically inject Authorization header
api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers = config.headers ?? {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Centralized error handling: auto-logout on 401/403
 api.interceptors.response.use(
   (response) => response,
   (error) => {
      const status = error?.response?.status;
      if (status === 401 || status === 403) {
        try { logoutUser(); } catch {}
        if (typeof window !== "undefined" && window.location.pathname !== "/login") {
          window.location.assign("/login");
        }
      }
      return Promise.reject(error);
    }
 );

export default api;